var map = {
	"./ic-cloud.svg": "482d",
	"./ic-flag-brazil.svg": "e730",
	"./ic-flag-paraguay.svg": "4da6",
	"./ic-flag-usa.svg": "5f28",
	"./ic-rain.svg": "dacb",
	"./ic-soybean-green.svg": "5d79",
	"./ic-soybean.svg": "716d",
	"./ic-sun.svg": "9b3c",
	"./ic-wheat-green.svg": "3e56",
	"./ic-wheat.svg": "a6d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";